import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'sd-opp-widget',
  templateUrl: './opp-widget.component.html',
  styleUrls: ['./opp-widget.component.scss']
})
export class OppWidgetComponent implements OnInit {

    @Input() data: any;
    @Input() myoppStatus: boolean;
    opp: any;
    from = '';
    fromForGA = '';

    typeLabel = '';
    partnerName = '';
    isUpcoming = false;
    isClosed = false;
    isApplied = false;
    isClosingSoon = false;
    subtitle = '';
    languages = '';
    isNew = false;
    hasImage = false;

    constructor(
        public global: GlobalService,
        public router: Router
    ) { }

    ngOnInit() {
        if ( !this.data.skeletonLoading ) {
            this.opp = this.data.opp;
            this.from = this.data.from || '';
            this.fromForGA = this.from + ': ' + this.opp.oppor_slug;

            this.typeLabel = this.global.replace(this.opp.opportunity_types_choice || '', '_', ' ');

            this.partnerName = this.opp.partner_name || this.typeLabel;

            this.isUpcoming = !!this.opp.is_upcoming_opportunity;

            if ( this.isUpcoming ) {
                this.isClosed = false;
            } else if ( this.opp.open !== undefined && this.opp.open !== null ) {
                this.isClosed = !this.opp.open;
            } else {
                this.isClosed = this.global.daysLeft(this.opp.last_date_application) < 0;
            }

            this.isApplied = !!this.opp.is_applied && !this.isClosed;

            this.isClosingSoon = !this.isUpcoming && !this.isClosed && !this.isApplied
                && this.global.daysLeft(this.opp.last_date_application) <= 3;

            this.subtitle = this.opp.subheading || '';

            const lang = this.opp.opportunity_language || '';
            const list = lang.split(',').map(l => l.trim()).filter(l => l);
            if ( list.length > 0 ) {
                const shown = list.slice(0, 4).join(' • ');
                const remaining = list.length - 4;
                this.languages = remaining > 0 ? `${shown} +${remaining} More` : shown;
            }

            if ( this.opp.published_date ) {
                const ageInDays = (Date.now() - new Date(this.opp.published_date).getTime()) / 86400000;
                this.isNew = ageInDays >= 0 && ageInDays <= 7;
            }

            this.hasImage = !!this.opp.card_image;
        }
    }

    goToOppDetailPage(event) {
        event.stopPropagation();

        if ( this.opp.direct && this.opp.direct !== '' ) {
            location.href = this.opp.direct;
        } else {
            this.router.navigate(['/' + this.global.oppDetailPrefix + '/' + this.opp.oppor_slug]);
        }
    }

    trackOppWidgetEvent(eventCategory, eventAction, eventLabel = this.router.url) {
        if (this.data.dashboardWidgetPosition && this.data.dashboardWidgetPosition > 0) {
            eventLabel = 'P' + this.data.dashboardWidgetPosition + ' ' + eventLabel;
        }
        this.global.trackEvent(eventCategory, eventAction, eventLabel);
    }
}
